export enum PageState {
  LANDINGS_PAGE = 0,
  UPLOAD_PAGE = 1,
  THANKS_PAGE = 2
}

export enum AppUrl {
  PRODUCTION = 'www.ns.nl',
  ACCEPTATION = 'acc.ns.nl',
  TEST = 'test.ns.nl',
  DEVELOPMENT = 'localhost'
}
